import ChooseCategory from "../components/CreateAuctionListingForm/ChooseCategory";
import Container from "../components/layout/Container";
import FilterHeader from "../components/Shared/FilterHeader/FilterHeader";
import MyAccount from "../components/Shared/MyAccount/MyAccount";
import ClassifiedCustomForm from "../components/ClassifiedPropertyCustomFieldForm/ClassifiedPropertyCustomForm";

const ClassifiedPropertyCustomFieldForm = () => {
  return (
    <Container>
      <div className="flex items-start justify-between gap-x-6">
        <MyAccount />
        <div className="grow">
          <FilterHeader
            title={"Creating Acution Listing"}
            dropdown={false}
            className="mt-[60px]"
          />
          <ChooseCategory />
          <ClassifiedCustomForm />
        </div>
      </div>
    </Container>
  );
};

export default ClassifiedPropertyCustomFieldForm;
